// Selection of tools to visually indicate keyboard shorcuts.
import * as React from 'react';
/** Converts an array of strings representing keys to look like keyboard keys. */
export function formatShortcuts(...shortcuts) {
    return shortcuts.map(s => formatShortcut(s)).join(" or ");
}
/** Formats a single keyboard shortcutp. */
function formatShortcut(shortcut) {
    var formatted = "";
    if (shortcut.ctrl) {
        formatted += `<span class="keyboardKey">${ctrlKey()}</span> + `;
    }
    formatted += `<span class="keyboardKey">${shortcut.key}</span>`;
    return formatted;
}
/** Returns true if the current system is a Mac. */
export function isMac() {
    return navigator.userAgent.indexOf('Mac') !== -1;
}
/** Returns ⌘ for Macs, Ctrl otherwise. */
export function ctrlKey() {
    return isMac() ? "⌘" : "Ctrl";
}
export const Key = (props) => (React.createElement(React.Fragment, null,
    props.ctrl ? React.createElement(React.Fragment, null,
        React.createElement(CtrlKey, null),
        " + ") : null,
    React.createElement("span", { className: "keyboardKey" }, props.k)));
export const FAKey = (props) => (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "keyboardKey" },
        React.createElement("i", { className: `fa${props.icon}` }))));
export const CtrlKey = () => (React.createElement("span", { className: "keyboardKey" }, ctrlKey()));
